<container-padrao>

    <div class="recomendacao" safeHtmlRecomendacao [innerHTML]="currentText | safeHtmlRecomendacao"></div>

</container-padrao>